@switch (state().status) {
  @case ("loading") {
    <div class="flex items-center gap-2 py-3 text-sm text-neutral-500">
      <guarantees-spinner></guarantees-spinner>
      {{ "guaranteeV2.message.processOptionsLoading" | translate }}
    </div>
  }
  @case ("error") {
    <guarantees-callout
      tone="error"
      icon="error"
    >
      {{ "guaranteeV2.message.processOptionsError" | translate }}
      <button
        class="ml-1 font-semibold underline"
        type="button"
        (click)="retry()"
      >
        {{ "guaranteeV2.action.retry" | translate }}
      </button>
    </guarantees-callout>
  }
  @case ("none") {
    <p class="text-sm text-neutral-400">{{ "guaranteeV2.message.noFlexiblePackage" | translate }}</p>
  }
  @default {
    @if (!directMatch() && hasOptions()) {
      <guarantees-callout
        tone="warning"
        icon="info"
      >
        {{ "guaranteeV2.message.noDirectOptionMatch" | translate }}
      </guarantees-callout>
    }

    @if (matchedOptions().length) {
      <ul
        class="flex flex-col gap-1.5"
        role="radiogroup"
        [attr.aria-label]="'guaranteeV2.label.packageOption' | translate"
      >
        @for (option of matchedOptions(); track option.id) {
          <ng-container *ngTemplateOutlet="optionCard; context: { $implicit: option }"></ng-container>
        }
      </ul>
    }

    <!-- Options that do not fit stay one select away: a manager may knowingly draw the line against a neighbouring one. -->
    @if (otherOptions().length) {
      <div class="flex flex-col gap-1.5">
        <span class="text-xs font-semibold text-neutral-500">
          {{ (matchedOptions().length ? "guaranteeV2.label.otherPackageOption" : "guaranteeV2.label.packageOption") | translate }}
        </span>
        <guarantees-option-picker
          [options]="otherPickerOptions()"
          [placeholder]="'guaranteeV2.message.otherPackageOptionPlaceholder' | translate"
          [value]="chosenOther()?.id ?? ''"
          (valueChange)="selectOther($event)"
        ></guarantees-option-picker>
        @if (chosenOther(); as option) {
          <ul class="flex flex-col gap-1.5">
            <ng-container *ngTemplateOutlet="optionCard; context: { $implicit: option }"></ng-container>
          </ul>
        }
      </div>
    }

    @if (!hasOptions()) {
      <p class="text-sm text-neutral-400">{{ "guaranteeV2.message.packageHasNoOptions" | translate }}</p>
    }
  }
}

<ng-template
  #optionCard
  let-option
>
  @let selected = isSelected(option.id);
  <li class="flex flex-col gap-1">
    <button
      guaranteesToggle
      shape="card"
      layout="block"
      align="start"
      type="button"
      role="radio"
      [pressed]="selected"
      [attr.aria-checked]="selected"
      (click)="select(option)"
    >
      <mat-icon class="mt-0.5 h-4! w-4! shrink-0 text-base! leading-4!">{{ selected ? "radio_button_checked" : "radio_button_unchecked" }}</mat-icon>
      <span class="flex min-w-0 flex-1 flex-col gap-1">
        <span class="font-semibold">{{ option.name }}</span>
        @if (option.limits?.length) {
          <guarantees-package-limits [limits]="option.limits"></guarantees-package-limits>
        }
      </span>
    </button>

    <!-- Sub-options belong to the chosen option, so only its own are offered. -->
    @if (selected && option.subOptions.length) {
      <ul class="ml-6 flex flex-col gap-0.5 border-l border-neutral-100 pl-3">
        @for (sub of option.subOptions; track sub.id) {
          <li>
            <button
              class="flex w-full items-start gap-2 rounded-md px-1.5 py-1 text-left text-sm transition-colors duration-150 hover:bg-neutral-50 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none motion-reduce:transition-none"
              type="button"
              role="checkbox"
              [attr.aria-checked]="isSubSelected(sub.id)"
              (click)="toggleSub(option, sub.id)"
            >
              <guarantees-check-box
                class="mt-0.5"
                [checked]="isSubSelected(sub.id)"
              ></guarantees-check-box>
              <span class="flex min-w-0 flex-1 flex-col gap-0.5">
                <span class="text-neutral-700">{{ sub.name }}</span>
                @if (sub.limits?.length) {
                  <guarantees-package-limits [limits]="sub.limits"></guarantees-package-limits>
                }
              </span>
            </button>
          </li>
        }
      </ul>
    }
  </li>
</ng-template>
